(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[218],{

/***/ 9081:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/haulers",
      function () {
        return __webpack_require__(2826);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var GradientContainer = function(param) {
    var children = param.children, _light = param.light, light = _light === void 0 ? false : _light, _gradientDirection = param.gradientDirection, gradientDirection = _gradientDirection === void 0 ? "bg-gradient-to-tl" : _gradientDirection, overrideClassName = param.overrideClassName;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat(gradientDirection, " ").concat(light ? "from-[#86EFAC] to-[#67E8F9]" : "from-[#22C55E] to-[#06B6D4]", "\n    ").concat(overrideClassName),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (GradientContainer);


/***/ }),

/***/ 2217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

var Input = function(_param) {
    var type = _param.type, label = _param.label, placeholder = _param.placeholder, labelClassName = _param.labelClassName, inputClassName = _param.inputClassName, inputProps = _objectWithoutProperties(_param, [
        "type",
        "label",
        "placeholder",
        "labelClassName",
        "inputClassName"
    ]);
    var labelDefaultClassName = "text-text-color-high-em";
    var inputDefaultClassName = "w-full rounded-lg border-[#D0D5DD] mt-1 text-text-color-high-em";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: labelClassName ? labelClassName : labelDefaultClassName,
                children: label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", _objectSpread({
                type: type ? type : "text",
                placeholder: placeholder,
                className: "".concat(inputDefaultClassName, " ").concat(inputClassName)
            }, inputProps))
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Input);


/***/ }),

/***/ 2826:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ haulers; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./components/gradient/gradient-container.tsx
var gradient_container = __webpack_require__(9467);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/haulers-sections/engagement-section/bottom-content.tsx


var EngagementSectionBottomContent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "grid grid-cols-12 gap-y-6 md:gap-x-4 lg:gap-x-8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-span-12 md:col-span-5 lg:col-span-6 flex justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/images/haulers/engagement-02.png",
                        alt: "Market Details",
                        width: 560,
                        height: 444
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "col-span-12 md:col-span-7 lg:col-span-6 flex flex-col justify-center items-center md:items-start space-y-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "mobile-h3 md:h4 lg:h3 text-center md:text-left",
                        children: "Operations Enhancement"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "p-6 md:max-w-[480px] border border-1 border-white/50 bg-black/20 rounded-lg shadow-2xl backdrop-blur-xl",
                        children: "SimpleWaste innovation creates fast-paced vendor engagement, streamlining opportunities to the most qualified participants. Access the right markets, bids, and details quickly."
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var bottom_content = (EngagementSectionBottomContent);

;// CONCATENATED MODULE: ./components/haulers-sections/engagement-section/header.tsx

var EngagementSectionHeader = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "grid grid-cols-12 w-full max-w-[1120px]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "col-span-12 flex flex-col space-y-4 text-center md:text-left",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "mobile-h2 md:h3 lg:h2",
                    children: "Your region of engagement"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "subheading",
                    children: "We make sure you arrive at your destination."
                })
            ]
        })
    });
};
/* harmony default export */ var header = (EngagementSectionHeader);

;// CONCATENATED MODULE: ./components/haulers-sections/engagement-section/mid-content.tsx


var EngagementSectionMidContent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col-reverse md:grid md:grid-cols-12 md:gap-x-4 lg:gap-x-8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-6 md:mt-0 md:col-span-7 lg:col-span-6 flex flex-col justify-center items-center md:items-end space-y-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "mobile-h3 md:max-w-[480px] md:h4 lg:h3 text-center md:text-left",
                        children: "Optimize Your Market Opportunities"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "p-6 lg:max-w-[480px] border border-1 border-white/50 bg-black/20 rounded-lg shadow-2xl backdrop-blur-xl",
                        children: "Interested in the SimpleWaste preferred vendor program? New opportunities are available every week and in your markets."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "md:col-span-5 lg:col-span-6 flex justify-center items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/images/haulers/engagement-03.png",
                        alt: "Market Details",
                        width: 560,
                        height: 313
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var mid_content = (EngagementSectionMidContent);

;// CONCATENATED MODULE: ./components/haulers-sections/engagement-section/top-content.tsx


var EngagementSectionTopContent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "grid grid-cols-12 gap-y-6 md:gap-x-4 lg:gap-x-8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-span-12 md:col-span-5 lg:col-span-6 flex justify-center items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/images/haulers/engagement-01.png",
                        alt: "Market Details",
                        width: 560,
                        height: 444
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "col-span-12 md:col-span-7 lg:col-span-6 flex flex-col justify-center items-center md:items-start space-y-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "mobile-h3 md:h4 lg:h3",
                        children: "Market Details"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "p-6 md:max-w-[480px] border border-1 border-white/50 bg-black/20 rounded-lg shadow-2xl backdrop-blur-xl",
                        children: "We provide our vendor partners a distinct market advantage through an extensive review of logistics, environment, landfills, and opportunities."
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var top_content = (EngagementSectionTopContent);

;// CONCATENATED MODULE: ./components/haulers-sections/engagement-section/index.tsx






var EngagementSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_container/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            className: "py-16 px-8 md:p-12 lg:p-24 text-light flex flex-col items-center space-y-16",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(header, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(top_content, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(mid_content, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(bottom_content, {})
            ]
        })
    });
};
/* harmony default export */ var engagement_section = (EngagementSection);

;// CONCATENATED MODULE: ./components/haulers-sections/equipped-section/bottom-content.tsx



var EquippedSectionBottomContent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col-reverse md:grid md:grid-cols-12 w-full md:gap-x-4 lg:gap-x-16",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-8 md:mt-0 md:col-span-6 flex flex-row justify-end items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "md:w-[560px] flex flex-col items-start space-y-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "mobile-h3 md:h4 lg:h3 text-text-color-high-em",
                            children: "Strategic Advantages"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_container/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-2 w-40"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-body-lg text-text-color-mid-em",
                            children: "We\u2019re continually looking for the most dependable providers in the industry. Be at an industry advantage through our \u201Canywhere accessible\u201D platform."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "md:col-span-6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex justify-center md:justify-start items-center h-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/images/haulers/equipped-02.png",
                        alt: "Equipped",
                        width: 550,
                        height: 519
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var equipped_section_bottom_content = (EquippedSectionBottomContent);

;// CONCATENATED MODULE: ./components/haulers-sections/equipped-section/header.tsx


var EquippedSectionHeader = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "grid items-center gap-y-4 w-full md:w-[440px] text-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "mobile-h3 md:h3 text-background-primary-dark",
                children: "Equipped to compete"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_container/* default */.Z, {
                overrideClassName: "mx-auto",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "h-2 w-40"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "subheading text-text-color-mid-em",
                children: "Hit the ground running"
            })
        ]
    });
};
/* harmony default export */ var equipped_section_header = (EquippedSectionHeader);

;// CONCATENATED MODULE: ./components/haulers-sections/equipped-section/top-content.tsx



var EquippedSectionTopContent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "grid grid-cols-12 w-full gap-y-8 md:gap-x-4 lg:gap-x-16",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-span-12 md:col-span-6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex justify-center md:justify-end items-center h-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/images/haulers/equipped-01.png",
                        alt: "Equipped",
                        width: 550,
                        height: 579
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-span-12 md:col-span-6 flex flex-row items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "md:w-[560px] flex flex-col items-start space-y-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "mobile-h3 md:h4 lg:h3 text-text-color-high-em",
                            children: "Exclusive Technology"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_container/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-2 w-40"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-body-lg text-text-color-mid-em",
                            children: "The SimpleWaste technology platform provides a vendor-facing interface designed to connect service with opportunity. Set bidding preferences to fit your service areas and waste profiles."
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var equipped_section_top_content = (EquippedSectionTopContent);

;// CONCATENATED MODULE: ./components/haulers-sections/equipped-section/index.tsx




var EquippedSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "py-16 px-8 md:p-12 lg:p-24",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col items-center space-y-16",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(equipped_section_header, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(equipped_section_top_content, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(equipped_section_bottom_content, {})
            ]
        })
    });
};
/* harmony default export */ var equipped_section = (EquippedSection);

;// CONCATENATED MODULE: ./components/haulers-sections/focus-section/index.tsx


var FocusSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "px-8 pt-8 md:px-24 md:pt-24 bg-background-low-em",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "grid grid-cols-12 max-w-[1440px] mx-auto",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-span-12 lg:col-span-6 flex flex-col justify-center items-end pb-8",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col space-y-6 md:text-left w-full text-text-color-mid-em text-body-xl",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex space-x-5 items-center btn-text-xs xs:btn-text-base",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "bg-secondary-dark text-light px-2 py-1 rounded-full",
                                        children: "New Feature"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-secondary-dark",
                                        children: "Built for growth"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "mobile-h1 md:h3 lg:h1 text-background-primary-dark",
                                children: "Focus on Business, not Bidding."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Look no further. Here, opportunities find you."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "We\u2019re in the business of connecting the most qualified vendors to the best possible opportunities."
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-span-12 px-8 md:px-16 lg:col-span-6 flex items-end justify-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-col justify-end",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/images/haulers/focus.png",
                            alt: "focus",
                            width: 537,
                            height: 570
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var focus_section = (FocusSection);

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./components/button.tsx
var components_button = __webpack_require__(6625);
// EXTERNAL MODULE: ./components/input.tsx
var input = __webpack_require__(2217);
// EXTERNAL MODULE: ./lib/api.ts
var api = __webpack_require__(1895);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs + 1 modules
var react_toastify_esm = __webpack_require__(2920);
;// CONCATENATED MODULE: ./components/haulers-sections/join-us-section/bottom-content.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}








var JoinUsSectionBottomContent = function() {
    var ref2 = (0,react.useState)(""), email = ref2[0], setEmail = ref2[1];
    var handleSubscribe = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            var ref, res1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.next = 3;
                        return api/* frontendApi.post */.mR.post("web/signup-newsletter", {
                            email: email
                        }).then(function(res) {
                            return [
                                true,
                                res.data.message
                            ];
                        }).catch(function(err) {
                            var ref3, ref1;
                            return [
                                false,
                                (ref = (ref3 = err.response) === null || ref3 === void 0 ? void 0 : (ref1 = ref3.data) === null || ref1 === void 0 ? void 0 : ref1.message) !== null && ref !== void 0 ? ref : "Something went wrong"
                            ];
                        }).finally(function() {
                            return setEmail("");
                        });
                    case 3:
                        res1 = _ctx.sent;
                        if (res1[0]) {
                            react_toastify_esm/* toast.success */.Am.success(res1[1]);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSubscribe() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_container/* default */.Z, {
        overrideClassName: "flex justify-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "grid grid-cols-12 max-w-[1200px] my-16 mx-8 md:m-12 lg:m-20 gap-y-8 md:gap-x-8 text-light",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-span-12 md:col-span-6 flex flex-col items-end gap-y-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "mobile-h3 md:h3 w-full text-center md:text-left",
                            children: "Sign up for our newsletter."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-body-lg xs:subheading w-full text-center md:text-left",
                            children: "Be the first to know about everything we have."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-span-12 md:col-span-6 text-text-color-mid-em",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "xl:min-w-[500px] flex flex-col lg:flex-row items-center space-y-2 lg:space-y-0 lg:space-x-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                                inputClassName: "text-body-md xs:text-body-lg xs:h-12 mt-0 text-center md:text-left",
                                placeholder: "Enter your email",
                                value: email,
                                onChange: function(e) {
                                    return setEmail(e.target.value);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full xs:hidden",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                    buttonType: "secondary-light",
                                    full: true,
                                    onClick: handleSubscribe,
                                    children: "Subscribe"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full lg:w-auto hidden xs:block",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                    size: "xl",
                                    buttonType: "secondary-light",
                                    full: true,
                                    onClick: handleSubscribe,
                                    children: "Subscribe"
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var join_us_section_bottom_content = (JoinUsSectionBottomContent);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./components/haulers-sections/join-us-section/top-content.tsx




var JoinUsSectionTopContent = function() {
    var router = (0,next_router.useRouter)();
    var contents = [
        {
            title: "Technology",
            imagePath: "/assets/icons/mdi-cellphone.png",
            desc: "Our technology stack intuitively searches markets, infrastructure, and data, connecting service requests to qualified vendors."
        },
        {
            title: "Time",
            imagePath: "/assets/icons/mdi-clock-time-eight.png",
            desc: "Less time is wasted reviewing emails, searching databases, and filling out endless bid requests."
        },
        {
            title: "Platform",
            imagePath: "/assets/icons/mdi-clipboard-text-multiple.png",
            desc: "We provide the right platform, equipped with suitable functions, creating strategic market engagement for our qualified vendor participants."
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "py-16 px-8 md:p-24 flex flex-col space-y-7 items-center text-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col space-y-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "h5 text-secondary-dark",
                        children: "Join us"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "mobile-h3 md:h3 text-text-color-high-em",
                        children: "Why haulers work with us?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "pt-2 md:max-w-[716px] text-text-color-mid-em",
                        children: "At SimpleWaste, we\u2019ve created a platform that connects client needs to service providers. Join our growing network of thousands of haulers today."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid grid-cols-12 gap-y-8 md:gap-x-8 text-text-color-mid-em",
                children: contents.map(function(content) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-span-12 md:col-span-4 flex flex-col items-center space-y-5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: content.imagePath,
                                alt: content.title,
                                height: 40,
                                width: 40
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col space-y-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "subheading",
                                        children: content.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "md:max-w-[384px]",
                                        children: content.desc
                                    })
                                ]
                            })
                        ]
                    }, content.title);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-row py-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                    onClick: function() {
                        return router.push("https://bidding.simplewaste.com/");
                    },
                    children: "Join Now"
                })
            })
        ]
    });
};
/* harmony default export */ var join_us_section_top_content = (JoinUsSectionTopContent);

;// CONCATENATED MODULE: ./components/haulers-sections/join-us-section/index.tsx



var JoinUsSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(join_us_section_top_content, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(join_us_section_bottom_content, {})
        ]
    });
};
/* harmony default export */ var join_us_section = (JoinUsSection);

;// CONCATENATED MODULE: ./pages/haulers.tsx





var HaulersPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(focus_section, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(equipped_section, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(engagement_section, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(join_us_section, {})
        ]
    });
};
/* harmony default export */ var haulers = (HaulersPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(9081); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);